import { Image, StyleSheet, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { Svg } from "assets/svg";
import VText from "components/VText";
import { Images } from "assets";
import { useSelector } from "react-redux";

const chatEmptyView = ({ onOptionPress, onCameraPress }) => {
    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
    return (
        <View style={{ marginVertical: spV(10), alignItems: "center" }}>
            <VText style={styles.helpText}>Hi, {userProfile?.name}</VText>
            <VText style={[styles.helpText, { marginTop: 2 }]}>How can I help you?</VText>

            <VText style={styles.description}>
                From personalized product search to customized outfit styling, the Vêtir AI stylist is here to assist
                with all of your style needs.
            </VText>
            <View style={[styles.optionsContainer, { marginTop: spV(20) }]}>
                <TouchableOpacity
                    style={styles.optionButton}
                    onPress={() => onOptionPress("Search for a product I would like")}
                >
                    <Image source={Svg.blueSearchIcon} style={styles.optionIcon} accessibilityLabel="Search Icon" />
                    <VText style={styles.optionText}>Search for a product I would like</VText>
                </TouchableOpacity>

                <TouchableOpacity
                    style={styles.optionButton}
                    onPress={() => onOptionPress("Help me style an outfit to wear")}
                >
                    <Image source={Svg.blueOutfitIcon} style={styles.optionIcon} accessibilityLabel="Outfit Icon" />
                    <VText style={styles.optionText}>Help me style an outfit to wear</VText>
                </TouchableOpacity>

                <TouchableOpacity style={styles.optionButton} onPress={onCameraPress}>
                    <Image source={Svg.cameraIcon} style={styles.optionIcon} accessibilityLabel="Camera Icon" />
                    <VText style={styles.optionText}>{"Find and shop a product from a picture"}</VText>
                </TouchableOpacity>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    description: {
        marginTop: spV(10),
        fontSize: fp(20),
        width: wp(650),
        fontWeight: "300",
        textAlign: "center",
        lineHeight: fp(30),
    },
    optionsContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: spV(20),
        gap: spH(10),
    },
    optionButton: {
        alignItems: "center",
        // justifyContent: "center",
        width: wp(160),
        height: hp(120),
        borderWidth: 1,
        borderColor: "#2124274D",
        borderRadius: 1,
        padding: spH(10),
        paddingTop: spV(20),
    },
    optionIcon: {
        width: wp(25),
        height: hp(25),
        marginBottom: spV(10),
    },
    optionText: {
        fontSize: fp(14),
        fontWeight: "350",
        textAlign: "center",
    },
    helpText: {
        marginTop: spV(15),
        fontSize: fp(28),
        fontWeight: "700",
        textAlign: "center",
        color: "rgba(90, 90, 90, 1)",
    },
});

export default chatEmptyView;
